module.exports = __webpack_public_path__ + "4e985cfeb73bf6ed1ab29cfe049edbd5.svg";